import bwipjs from "bwip-js";

export const generateBarcodeBase64 = (text) => {
  return new Promise((resolve, reject) => {
    try {
      const canvas = document.createElement("canvas");

      bwipjs.toCanvas(canvas, {
        bcid: "code128",
        text: text,
        scale: 3,
        height: 10,
        includetext: false
      });

      const base64 = canvas.toDataURL("image/png");
      resolve(base64);

    } catch (err) {
      console.error(err);
      reject(err);
    }
  });
};